import styled from "styled-components";
import { BaseRow } from "../BaseRow/BaseRow";

export const ActionsWrapper = styled(BaseRow)<{ justify: string }>`
  display: flex;
  justify-content: ${(props) => props.justify || "end"}; /* Align children dynamically */
  align-items: center; /* Center children vertically */
  gap: 1rem; /* Add spacing between buttons */
  margin: 0.5rem 0;
`;
